import { createContext } from 'react';
var LocaleContext = createContext(undefined);
export default LocaleContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/locale-provider/context.js
// module id = 240
// module chunks = 0